import React from "react";
import SiteHeader from "../components/SiteHeader";
import Reveal from "../components/Reveal";
import ApplicationForm, { ApplicationField } from "../components/ApplicationForm";
import { IconCheck } from "../components/Icons";
import { CAMIGUIN_TOWNS, RIDER_AREA, RIDER_PERKS, RIDER_REQUIREMENTS, RIDER_TERMS, RIDER_VERIFICATION } from "../data/riders";
import { useDocumentMeta } from "../useDocumentMeta";

/* Deliberately short: name, number, town. Documents are listed as
   requirements and checked in person, never uploaded here. */
const FIELDS: ApplicationField[] = [
  { name: "fullName", label: "Full name", type: "text", required: true, autoComplete: "name", placeholder: "Juan Dela Cruz", full: true },
  { name: "phone", label: "Mobile number", type: "tel", required: true, autoComplete: "tel", placeholder: "09XX XXX XXXX" },
  { name: "town", label: "Town", type: "select", required: true, options: CAMIGUIN_TOWNS },
];

const RidersPage: React.FC = () => {
  useDocumentMeta({
    title: "Become a PABS rider — Apply in a minute",
    description: `Apply to ride with PABS in ${RIDER_AREA}. Deliver food and groceries, run Pasugo errands, and give Angkas rides as an independent rider partner. Leave your name and number and we'll call you.`,
    canonicalPath: "/riders",
    ogImage: "https://pabs.online/logo512.png",
  });

  return (
    <>
      <SiteHeader current="/riders" />

      <main id="main" className="ct">
        <section className="ct__hero">
          <div className="ct__bg" aria-hidden="true" />
          <div className="u-container">
            <Reveal className="ct__head">
              <span className="t-eyebrow">Ride with PABS</span>
              <h1 className="t-h1 ct__title">
                Earn as a <span className="t-grad">PABS rider.</span>
              </h1>
              <p className="t-lead ct__lead">
                Leave your name and number, and our team will call you to set up
                your account. No documents to upload here.
              </p>
            </Reveal>

            <div className="ct__layout">
              <Reveal className="ct__aside">
                <div className="ct__panel">
                  <h2 className="ct__panel-title">Why ride with PABS</h2>
                  <ul className="ap__list">
                    {RIDER_PERKS.map((p) => (
                      <li key={p}>
                        <IconCheck size={16} />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="ct__panel">
                  <h2 className="ct__panel-title">What you'll need</h2>
                  <ul className="ap__list">
                    {RIDER_REQUIREMENTS.map((r) => (
                      <li key={r}>
                        <IconCheck size={16} />
                        {r}
                      </li>
                    ))}
                  </ul>
                  <p className="ap__note">
                    Bring these when we meet. {RIDER_VERIFICATION} Carrying
                    passengers on Angkas needs a separate clearance.
                  </p>
                </div>

                <div className="ct__panel">
                  <h2 className="ct__panel-title">Good to know</h2>
                  <ul className="ap__list">
                    {RIDER_TERMS.map((t) => (
                      <li key={t}>
                        <IconCheck size={16} />
                        {t}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>

              <Reveal delay={100} className="ct__formwrap" id="apply">
                <ApplicationForm
                  source="Rider application"
                  fields={FIELDS}
                  nameField="fullName"
                  phoneField="phone"
                  submitLabel="Send application"
                  successMessage="Thanks for applying! Our team will call you on the number you gave us."
                />
              </Reveal>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default RidersPage;
